import { Routes } from '@angular/router';

import { DatacenterComponent } from '../shared/datacenter/datacenter.component';
import { DatacenterViewCustomizationComponent }
	from '../shared/datacenter/view-customization/datacenter-view-customization.component';
import { SERVICE_ANALYTICS } from '../shared/models/list';

export const routes: Routes = [
	{
		path: 'organization',
		children: [
			{
				path: '',
				redirectTo: 'datacenter',
				pathMatch: 'full',
				data: { pageName: 'Redirect' }
			},
			{
				path: 'datacenter',
				children: [
					{
						path: '',
						component: DatacenterComponent,
						data: {
							pageName: 'Organizations - Datacenter',
							service: SERVICE_ANALYTICS.ORGANIZATIONS,
							type: 'organization',
							title: 'datacenter.organizations',
							exportExcelName: 'Organizations'
						}
					},
					{
						path: 'view',
						component: DatacenterViewCustomizationComponent,
						data: { pageName: 'Organizations - Datacenter Customization',
							service: SERVICE_ANALYTICS.ORGANIZATIONS }
					}
				]
			},
		]
	}
];
